import { InvoiceDocumentItem } from '@/components/Payouts/InvoiceDocumentItem';
import { Box, Spinner } from '@palmetto/palmetto-components';
import React from 'react';

import { DocumentDocument } from 'types';

interface InvoiceDocumentListProps {
  isLoading: boolean;
  invoices: Array<DocumentDocument>;
}

export const InvoiceDocumentList: React.FC<InvoiceDocumentListProps> = ({ isLoading, invoices }) => {
  if (isLoading) {
    return <Spinner size="lg" />;
  }

  return (
    <Box childGap="sm" width="100" padding="lg" borderWidth="xs 0 0 0" borderColor="separator">
      {invoices.length > 0 ? (
        <>
          <Box
            borderWidth="0 0 xs 0"
            borderColor="separator"
            direction="row"
            padding="md 0"
            childGap="3xl"
            fontSize="xs"
            fontWeight="bold"
          >
            <Box width="20">INVOICE NUMBER</Box>
            <Box width="20">RECEIPT DATE</Box>
            <Box>FILENAME</Box>
          </Box>
          {invoices.map((invoice) => (
            <InvoiceDocumentItem key={invoice.id?.toString()} document={invoice} />
          ))}
        </>
      ) : (
        <Box display="block" textAlign="center" padding="lg">
          <Box fontSize="sm" color="body-secondary">
            No invoices available
          </Box>
        </Box>
      )}
    </Box>
  );
};
